module.exports = __webpack_public_path__ + "static/img/banner.fa819b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/applyprocess/banner.png
// module id = MWJz
// module chunks = 1